<script setup>
import RenduFicheAim from '@/components/fiche-aim/fiche-aim/rendu-fiche-aim.vue'
import SStepCardPanels from '@/components/global/step-card-pannel/s-step-card-panels.vue'
import AjustementsAim from '@/components/fiche-aim/fiche-aim/ajustement/ajustements-aim.vue'
import VersementsAim from '@/components/fiche-aim/fiche-aim/versements/versements-aim.vue'
import SelecteurFicheAim from '@/components/fiche-aim/selecteur-fiche-aim.vue'
</script>

<template>
  <s-step-card-panels
    v-if="!loading && ficheAim !== undefined"
    titre-premier-panel="Préparation des ajustement"
    titre-second-panel="Préparation des versements"
    :sousTitre="sousTitreFicheAIM"
    @step-prev="tearDownVersement"
  >
    <template #sous-titre>
      <selecteur-fiche-aim :fiche-actuelle="ficheAim" />
    </template>
    <template #first-panel>
      <ajustements-aim
        class="fixed-height"
        :read-only="!ficheAim.modifiable"
        :ajustements="ficheAim.ajustements"
      ></ajustements-aim>
    </template>
    <template #second-panel="{ etape }">
      <rendu-fiche-aim class="fixed-height" :fiche-aim="ficheAim" :mode-versement="etape === 2"></rendu-fiche-aim>
    </template>
    <template #third-panel>
      <versements-aim
        class="fixed-height"
        :usagerId="ficheAim.usager.usagerId"
        :annee="ficheAim.annee"
        :mois="ficheAim.mois"
      ></versements-aim>
    </template>
  </s-step-card-panels>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'preparation-fiche-aim',
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      getficheById: 'ficheAIM/getFicheAimById',
      getMonthLabel: 'calendrier/getMonthLabel',
    }),
    ficheAimId() {
      return parseInt(this.$route.params.ficheAimId)
    },
    ficheAim() {
      return this.getficheById(this.ficheAimId)
    },
    nomComplet() {
      return this.ficheAim.usager.etatCivil.nomComplet.nom + ' ' + this.ficheAim.usager.etatCivil.nomComplet.prenom
    },
    sousTitreFicheAIM() {
      return this.nomComplet + ' - ' + this.getMonthLabel(this.ficheAim.mois) + ' ' + this.ficheAim.annee
    },
  },

  methods: {
    ...mapActions({
      fetchFicheAimById: 'ficheAIM/fetchFicheAimByFicheId',
      razAllPreparationVersement: 'preparationVersement_IHM_helper/razAll',
    }),
    tearDownVersement() {
      this.razAllPreparationVersement()
    },
  },
  beforeMount() {
    this.fetchFicheAimById(this.ficheAimId).then(() => (this.loading = false))
  },
}
</script>
